import React from "react";
import styled from "styled-components";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Root = styled.div`
  width: 100%;
`;
const Container = styled.div`
  justify-content: center;
  align-items: center;
`;

const ImagewrapperTwo = styled.div`
  background-size: cover;
  background-position: center;
  width: 100%;
  z-index: 999;
  background-repeat: no-repeat;
  margin: 20px 0;
  border-radius: 10px;
`;
const Image = styled.img`
  /* width: 100%;
  border-radius: 15px; */
`;

const BannerTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  position: absolute;
  bottom: 40px;
  left: 60px;
  @media(max-width:768px){
    left: 40px;
  }
  
`;
const BannerText = styled.text`
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 54px;
  text-transform: capitalize;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: 'Lato';
  position: relative;
  
  @media (max-width: 660px) {
    font-size: 28px;
  }
  @media (max-width: 390) {
    font-size: 24px;
  }
`;
const BannersmallText = styled.text`
  padding: 0px 0px 20px;
  color: #c7c7c7;
  font-size: 24px;
  font-weight: 600;
`;
const BannerSubText = styled.text`
    background-color: #17293052;
    border-radius: 50px;
    padding: 15px 60px;
    color: #267383;
    border: 1px solid #26738373;
    font-size: 16px;
    font-family: 'Lato';
    font-weight: 600;
    margin-top: 10px;
    transition: 1s;
    cursor: pointer;
    &:hover {
      background-color: #fff;
      color: #000;
    }
    @media (max-width: 768px) {
      background-color: #fff;
      color: #000;
  }
    @media (max-width: 1024px) {
      background-color: #fff;
      color: #000;
  }
`;

const NftValueViewContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: absolute;
  bottom: 7px;
  background: linear-gradient(360deg, #000000 41.25%, rgba(0, 0, 0, 0) 100%);
`;
const ValueWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;
const ValueText = styled.text`
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-transform: capitalize;
  color: #ffffff;
  @media (max-width: 640px) {
    font-size: 15px;
  }
`;
const Value = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  text-transform: capitalize;
  margin: 5px 0;
  @media (max-width: 640px) {
    font-size: 15px;
  }
`;
const LineWrapper = styled.div``;
const Line = styled.div`
  opacity: 0.2;
  border: 1px solid #ffffff;
  height: 58px;
  width: 0;
  margin: 0 30px;
  @media (max-width: 640px) {
    margin: 0 10px;
  }
`;
const NftCategory = styled.div`
  font-size: 8px;
    font-weight: 800;
    color: #490d81;
    text-transform: uppercase;
    background-color: #d3b1f3;
    padding: 0px 10px;
    border-radius: 50px;
    position: absolute;
    top: -20px;
    left: 0;
    line-height: 24px;
    width: 67px;
      ${(p)=>p.rare && `
      background-color: #a5e3b8;
      color: #2b713e;
      `};
      ${(p)=>p.common && `
        background-color: #dddddd;
        color: #535353;
      `};
`;
const NftCategory1 = styled.div`
    font-size: 12px;
    font-weight: 800;
    color: #2a831b;
    text-transform: uppercase;
    background-color: #cce7d5;
    padding: 0px 20px;
    border-radius: 50px;
    position: absolute;
    top: -20px;
    left: 75px;
    line-height: 24px;
`;

const BannerTrandingNft = () => {
  var settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    infinite: true,
    dots: true,
  };

  return (
    <Root>
      <Container>
        <Slider {...settings}>
          <Imagewrapper>
            <BannerTextWrapper>
              <div>
              <BannerText>Fangs of Fury
              <NftCategory>Legendary</NftCategory>
              <NftCategory1>#7,101</NftCategory1>
              </BannerText>
              <BannersmallText>45.32 USD</BannersmallText>
              </div>
              <BannerSubText>Buy Now</BannerSubText>
            </BannerTextWrapper>
          </Imagewrapper>

          <Imagewrapper>
            <BannerTextWrapper>
              <div>
              <BannerText>Sting Ray Rifle
              <NftCategory rare>Rare</NftCategory>
              <NftCategory1>#7,101</NftCategory1>
              </BannerText>
              <BannersmallText>45.32 USD</BannersmallText>
              </div>
              <BannerSubText>Buy Now</BannerSubText>
            </BannerTextWrapper>
          </Imagewrapper>

        </Slider>
      </Container>
    </Root>
  );
};

const Imagewrapper = styled.div`
  background-size: 100%;
  background-position: center;
  width: 100%;
  z-index: 999;
  background-repeat: no-repeat;
  margin: 20px 0;
  border-radius: 10px;
  height: 400px;
  transition: 1s;
  position: relative;
  @media (max-width: 768px) {
    background-size: cover !important;
  }
  @media (max-width: 1024px) {
    background-size: cover !important;
  }
  &:hover {
    background-size:110%;
  }
  &:hover ${BannerSubText}{
    background-color: #fff;
    color: #000;
  }
  

`;

export default BannerTrandingNft;
